import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({
  requireRole,
}: {
  requireRole?: string;
}) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Loading…
      </div>
    );
  }
  if (auth.status === "anonymous" || !auth.user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  if (requireRole && !auth.user.roles.includes(requireRole)) {
    return (
      <div className="p-8 max-w-2xl mx-auto text-slate-700">
        <h2 className="text-xl font-semibold text-rose-700">Access denied</h2>
        <p className="mt-2 text-sm">
          You do not have the required role <code>{requireRole}</code> to view
          this page.
        </p>
      </div>
    );
  }
  return <Outlet />;
}
